<template>
  <div>
    <page-title :title="title"></page-title>
    <div class="list-content">
      <template>
        <el-table
          :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
          :cell-style="cellStyle"
          :header-cell-style="rowClass"
          style="width: 80%">
          <el-table-column
            label="姓名"
            prop="name">
          </el-table-column>
          <el-table-column
            label="建档时间"
            prop="date"
            sortable
            column-key="date"
            :filters="[{text: '2016-05-01', value: '2016-05-01'}, {text: '2016-05-02', value: '2016-05-02'}, {text: '2016-05-03', value: '2016-05-03'}, {text: '2016-05-04', value: '2016-05-04'}]"
            :filter-method="filterHandler">
          </el-table-column>
          <el-table-column
            label="状态"
            prop="state"
            :filters="[{text: '处理中', value: 'nice'}, {text: '等待处理', value: 'good'}, {text: '已处理', value: 'well'}, {text: 'null', value: 'prety well'}]"
            :filter-method="filterHandler">
          </el-table-column>
          <el-table-column
            align="right">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="search"
                size="small"
                placeholder="输入关键字搜索"/>
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleDetail(scope.$index, scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="list-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="10">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import PageTitle from '../components/PageTitle'
import PageHeader from '../components/PageHeader'
export default {
  name: 'StuList',
  data () {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          state: 'wonderful'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          state: 'good'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          state: 'nice'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          state: 'well'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          state: 'so nice'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          state: 'good'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          state: 'prety well'
        }
      ],
      search: '',
      title: '学生列表'
    }
  },
  mounted () {
    console.log(localStorage.getItem('token'))
  },
  methods: {
    handleDetail (index, row) {
      this.$router.push({ name: 'detail', params: {index: index} })
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center;font-size:13px'
    },
    rowClass ({ row, rowIndex }) {
      return 'text-align:center'
    },
    headerStyle ({ row, rowIndex }) {
      return { 'font-size': '13px' }
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    }
  },
  components: {
    PageTitle,
    PageHeader
  }
}

</script>

<style lang="stylus" scoped>
@import url("//unpkg.com/element-ui@1.4.6/lib/theme-default/index.css")
  .list-content
    height 480px
    margin 60px 0px
    padding 20px
    .el-table
      margin 0 auto
      overflow hidden
      font-size 14px
  .list-footer
    width 800px
    text-align center
    margin 0 auto
</style>



// WEBPACK FOOTER //
// src/views/StudentList.vue